import { chainReducers } from 'src/utils/chainReducers';
import { KeyPhraseSynonymsState } from 'src/react/keyPhraseSynonyms/state/KeyPhraseSynonymsState';
import { keyPhraseSynonymsCheckReducer } from 'src/react/keyPhraseSynonyms/reducers/keyPhraseSynonymsCheckReducer';
import { keyPhraseSynonymsResetReducer } from 'src/react/keyPhraseSynonyms/reducers/keyPhraseSynonymsResetReducer';

export const keyPhraseSynonymsReducer = chainReducers<KeyPhraseSynonymsState>(
    keyPhraseSynonymsCheckReducer,
    keyPhraseSynonymsResetReducer,
);
